<template>
  <div class="article__price">
    <span class="article__amount">
      <slot />
    </span>
    <span v-if="cadence">/ Monat inkl. USt.</span>
    <span v-else>einmalig inkl. USt.</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    cadence: { type: String },
  },
})
</script>

<style lang="scss" scoped>
.article__price {
  @media (max-width: $bp-sm) {
    margin-bottom: $spacer10;
  }
}

.article__amount {
  font-size: 1.5em;
}
</style>